import { AlErrorTranslatorService } from './services/al-error-translator.service';
import { AlFileDownloadService } from './services/al-file-download-service';
import { AlExternalContentManagerService } from './services/al-external-content-manager.service';
import { AlTemplateIndexService } from './services/al-template-index.service';
import { AlToastService } from './services/al-toast.service';
import { AlUsageTrackingService } from './services/al-usage-tracking.service';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng-lts/button';
import { CalendarModule } from 'primeng-lts/calendar';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { ChipsModule } from 'primeng-lts/chips';
import { DialogModule } from 'primeng-lts/dialog';
import { DropdownModule } from 'primeng-lts/dropdown';
import { InputTextareaModule } from 'primeng-lts/inputtextarea';
import { InputTextModule } from 'primeng-lts/inputtext';
import { ListboxModule } from 'primeng-lts/listbox';
import { MenuModule } from 'primeng-lts/menu';
import { MultiSelectModule } from 'primeng-lts/multiselect';
import { PanelModule } from 'primeng-lts/panel';
import { ProgressSpinnerModule } from 'primeng-lts/progressspinner';
import { RadioButtonModule } from 'primeng-lts/radiobutton';
import { SidebarModule } from 'primeng-lts/sidebar';
import { TableModule } from 'primeng-lts/table';
import { ToastModule } from 'primeng-lts/toast';
import { ToolbarModule } from 'primeng-lts/toolbar';
import { TooltipModule } from 'primeng-lts/tooltip';
import { InputSwitchModule } from 'primeng-lts/inputswitch';
import { AutoCompleteModule } from 'primeng-lts/autocomplete';
import { AccordionModule } from 'primeng-lts/accordion';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { SelectButtonModule } from 'primeng-lts/selectbutton';
import { GalleriaModule } from 'primeng-lts/galleria';
import { InputNumberModule } from 'primeng-lts/inputnumber';

import { VirtualScrollerModule } from 'primeng-lts/virtualscroller';

import * as components from './components';
import { AlFilter2Component } from './al-filter2/al-filter2.component';
import * as newComponents from './new-components/components';
import { DecodesPipe } from './pipes';
import { Decode64Service, HighlightTextService, ChromaHash, HtmlViewService } from './services';

@NgModule({
    declarations: [
        ...components.ALL_COMMON,
        ...newComponents.ALL_NEW_COMMON,
        AlFilter2Component
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        CheckboxModule,
        ChipsModule,
        DialogModule,
        DropdownModule,
        InputTextModule,
        InputTextareaModule,
        ListboxModule,
        MenuModule,
        MultiSelectModule,
        PanelModule,
        OverlayPanelModule,
        SidebarModule,
        TableModule,
        ToastModule,
        ToolbarModule,
        TooltipModule,
        CalendarModule,
        ProgressSpinnerModule,
        RadioButtonModule,
        InputSwitchModule,
        AccordionModule,
        SelectButtonModule,
        AutoCompleteModule,
        GalleriaModule,
        InputNumberModule,
        VirtualScrollerModule
    ],
    exports: [
        ...components.ALL_COMMON,
        ...newComponents.ALL_NEW_COMMON
    ],
    providers: [
        AlErrorTranslatorService,
        AlExternalContentManagerService,
        AlTemplateIndexService,
        AlToastService,
        AlFileDownloadService,
        DatePipe,
        DecodesPipe,
        Decode64Service,
        HighlightTextService,
        ChromaHash,
        HtmlViewService
    ]
})
export class NgGenericComponentsModule { }
